export const SET_TOTAL_UNITS = 'Loader/SET_TOTAL_UNITS';
export const SET_LOADED_UNITS = 'Loader/SET_LOADED_UNITS';
export const INCREASE_LOADED_UNITS = 'Loader/INCREASE_LOADED_UNITS';
export const SHOW_LOADER = 'Loader/SHOW_LOADER';
export const HIDE_LOADER = 'Loader/HIDE_LOADER';
export const SET_LOADING_MESSAGE = 'Loader/SET_LOADING_MESSAGE';
export const SET_PROGRESS_PERCENT = 'Loader/SET_PROGRESS_PERCENT';
